import HostContext from "src/core/common/hostContext";
import RouteParamsContext from "src/core/common/routeParamsContext";
import {AppLoaderProvider} from "src/core/common/appLoaderProvider";
import SiteContext from "src/core/sites/context";
import {FeatureToggles, FeatureTogglesContext} from "src/core/common/featureToggles";
import {ThemeProvider} from "styled-components";
import BreadcrumbsProvider from "src/core/common/components/BreadcrumbsContext";
import {RecoilRoot} from "recoil";
import React, {useEffect, useState} from "react";
import getTymberApp from "src/apps/common/getTymberApp";
import {dispatchEvent} from "src/events/utils";
import {EventTypes} from "src/events/constants";

function BaseAppProvider({host, site, appIdentifier, routeParams, children}) {
  const [App, setApp] = useState(getTymberApp(appIdentifier));

  if (!App.initialized) App.init(site.env);

  useEffect(() => {
    const newApp = getTymberApp(appIdentifier);
    if (newApp !== App) {
      setApp(newApp);
      newApp.init(site.env);
      dispatchEvent(EventTypes.STORE_CHANGED);
    }

    App.initClient(site);
  }, [site]);

  return [
    {Provider: HostContext.Provider, props: {value: host}},
    {Provider: RouteParamsContext.Provider, props: {value: routeParams}},
    {Provider: AppLoaderProvider, props: {site: site, app: App}},
    {Provider: SiteContext.Provider, props: {value: site}},
    {
      Provider: FeatureTogglesContext.Provider,
      props: {value: FeatureToggles.getInstance(site)},
    },
    {Provider: ThemeProvider, props: {theme: site.getTheme()}},
    {Provider: BreadcrumbsProvider, props: {}},
    {Provider: RecoilRoot, props: {}},
  ]
    .reverse()
    .reduce((acc, {Provider, props}) => {
      return <Provider {...props}>{!acc ? children : acc}</Provider>;
    }, null);
}

export default BaseAppProvider;
